import { Component, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ContractResponse, ProfileDocumentResponse } from '../../../../../api';
import { baseAssignmentsActions, BaseCoreState } from '../../../../_store';
import { BaseButtonSize } from '../../../../shared/components/button/base-button.component';
import { BaseRolesService } from '../../../../core/services/base-roles.service';

@Component({
  selector: 'base-regenerate-contract-modal',
  templateUrl: './base-regenerate-contract-modal.component.html',
})
export class BaseRegenerateContractModalComponent {
  @Input() contract: ContractResponse | undefined;
  @Input() assignmentId: number;
  @Input() createdByMessage: string;
  @Input() sanitizedSrc: SafeResourceUrl | null = null;
  @Input() modalRef: NgbModalRef | undefined;

  isShowContractPreview = false;
  isContractUploadEnabled = false;
  uploadedContractFile: File | ProfileDocumentResponse | null = null;

  buttonSizes = BaseButtonSize;

  constructor(private store: Store<BaseCoreState>, private roleService: BaseRolesService) {}

  toggleContractPreview() {
    this.isShowContractPreview = !this.isShowContractPreview;
  }

  enableContractUpload(event: boolean): void {
    this.isContractUploadEnabled = event;
  }

  setUploadedContractFile(event: File | ProfileDocumentResponse | null): void {
    this.uploadedContractFile = event;
  }

  closeModal(): void {
    this.modalRef?.close();
  }

  updateContract(): void {
    if (this.isContractUploadEnabled) {
      this.uploadNewContract();
    } else {
      this.regenerateContract();
    }

    this.closeModal();
  }

  private uploadNewContract(): void {
    const callback = (contractId: number) => {
      this.regenerateContract(contractId);
    };
    this.store.dispatch(
      baseAssignmentsActions.uploadAssignmentContract({
        payload: {
          file: this.uploadedContractFile as File,
          callback,
        },
      })
    );
  }

  private regenerateContract(contract?: number) {
    const body = !!contract ? { contract } : undefined;
    if (this.roleService.isPsp()) {
      this.store.dispatch(
        baseAssignmentsActions.regeneratePspAssignmentContract({
          payload: {
            assignment: this.assignmentId,
            body,
          },
        })
      );
    } else {
      this.store.dispatch(
        baseAssignmentsActions.regenerateCustomerAssignmentContract({
          payload: {
            assignment: this.assignmentId,
            body,
          },
        })
      );
    }
  }
}
